@use '~/theme/theme' as *;

.lockedInstitutionLogoContainer {
  opacity: 0.4;
  width: 32px;
  height: 32px;
  background-color: color(grey-400);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lockedInstitutionLogoContainerIcon {
  color: color(grey-800);
}
